import * as type from "../../types/API/stockTransfer";

export function stockTransfer(payload: any) {
  return {
    type: type.STOCK_TRANSFER,
    payload: payload,
  };
}

export function getAllRejectStoreItems(payload: any) {
  return {
    type: type.GET_ALL_REJECT_STORE_ITEMS,
    payload: payload,
  };
}
